import { Injectable } from '@angular/core';
import { InveniasDataSourceApiService } from 'datasource-service-lib';
import { IEntityMetadata, IEntityMetadataService } from 'interfaces-lib';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InveniasEntityMetadataService implements IEntityMetadataService {
  private _cache: IEntityMetadata[] | null = null;

  constructor(private apiService: InveniasDataSourceApiService) {}

  getEntitiesMetadata(): Observable<IEntityMetadata[]> {
    if (this._cache) {
      return of(this._cache);
    }

    return this.fetchEntitiesMetadata().pipe(tap((data) => (this._cache = data))) as Observable<IEntityMetadata[]>;
  }

  private fetchEntitiesMetadata(): Observable<IEntityMetadata[]> {
    return this.apiService.meta().pipe(
      catchError((error) => {
        console.error(`Failed to load metadata`, error);
        throw error;
      })
    );
  }
}
